import { isPlainObject } from 'utilities/isPlainObject'
import { api } from './index'
import type {
  OrderStatusWebhookReceipt,
  OrderStatusWebhookReceiptsResponseWire,
  OrderStatusWebhookReceiptWire,
} from './orderStatusWebhookReceipts.types'

// Fail-soft wire→domain transform (mirrors liveUpdates.ts's transform*
// convention): a malformed element is dropped rather than crashing, and a
// non-array response coerces to an empty list.
export const transformOrderStatusWebhookReceipts = (
  response: OrderStatusWebhookReceiptsResponseWire
): OrderStatusWebhookReceipt[] =>
  Array.isArray(response)
    ? response
        .filter((receipt): receipt is OrderStatusWebhookReceiptWire =>
          isPlainObject(receipt)
        )
        .map(receipt => ({
          locationId: Number(receipt.location_id) || 0,
          provider:
            typeof receipt.provider === 'string' ? receipt.provider : '',
          lastReceivedAt: receipt.last_received_at ?? null,
        }))
    : []

export const orderStatusWebhookReceiptsApi = api.injectEndpoints({
  endpoints: builder => ({
    getOrderStatusWebhookReceipts: builder.query<
      OrderStatusWebhookReceipt[],
      void
    >({
      query: () => 'order_status_webhook_receipts',
      transformResponse: transformOrderStatusWebhookReceipts,
      providesTags: ['OrderStatusWebhookReceipts'],
    }),
  }),
})

export const { useGetOrderStatusWebhookReceiptsQuery } =
  orderStatusWebhookReceiptsApi
